import { render, staticRenderFns } from "./decision-criterion.vue?vue&type=template&id=0da0b807"
import script from "./decision-criterion.vue?vue&type=script&lang=ts"
export * from "./decision-criterion.vue?vue&type=script&lang=ts"
import style0 from "./decision-criterion.vue?vue&type=style&index=0&id=0da0b807&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da0b807')) {
      api.createRecord('0da0b807', component.options)
    } else {
      api.reload('0da0b807', component.options)
    }
    module.hot.accept("./decision-criterion.vue?vue&type=template&id=0da0b807", function () {
      api.rerender('0da0b807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/decision-model/decision-criterion.vue"
export default component.exports